import React from 'react'
import '../styles/Header.css'

import katiaDoodleToys from '../lettering/katia_doodle_toys.svg';
import figurkiRuchnoiRaboti from '../lettering/figurki_ruchnoi_raboti.svg';

const Header = () => {
  return (
    <header className='header'>
        <img src={katiaDoodleToys} alt="Doodle Toys Orange" className="katiaDoodleToys" />
        <img src={figurkiRuchnoiRaboti} alt="Figurki Ruchnoi Raboti" className="figurkiRuchnoiRaboti" />
      </header>
  )
}

export default Header